{
  "rwg-cancel-request-page": {
    "buttons": {
      "cancel": "Hủy bỏ",
      "submit": "Gửi đi",
      "to-home-page": "Về trang chủ"
    },
    "meta": {
      "title": "Beauty Pro - Yêu cầu hủy tích hợp lịch hẹn với Google",
      "description": "Điền vào biểu mẫu sau để yêu cầu hủy tích hợp lịch hẹn với Google"
    },
    "text": {
      "title": "Yêu cầu hủy tích hợp lịch hẹn với Google",
      "subtitle-salon-info": "Salon của bạn ở đâu?",
      "subtitle-owner-info": "Làm thế nào chúng tôi có thể liên lạc với bạn?",
      "email": "Email của bạn",
      "full-name": "Tên đầy đủ của bạn",
      "language": "Ngôn ngữ ưa thích của bạn để giao tiếp",
      "request-sent-success": "Yêu cầu của bạn đã được gửi thành công!",
      "request-confirmation-sent-to-your-email": "Xác nhận của chúng tôi sẽ được gửi đến e-mail của bạn. Vui lòng kiểm tra cả hòm thư rác của bạn!",
      "salon-address": "Địa chỉ tiệm của bạn",
      "salon-name": "Tên tiệm của bạn",
      "we-will-contact-soon": "Đội ngũ của chúng tôi rất hân hạnh được hỗ trợ bạn, và chúng tôi sẽ liên lạc trong thời gian sớm nhất để giải quyết yêu cầu của bạn."
    }
  }
}
